import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getCodes = async (params) => {
	const { data } = await axios.get(`${API}/admin/codes`, {
		params,
	});
	return data;
};

export const getCode = async (params) => {
	const { data } = await axios.get(`${API}/admin/codes/detail`, {
		params,
	});
	return data;
};

export const saveCode = async (params) => {
	const { data } = await axios.post(`${API}/admin/codes/save`, params);
	return data;
};

export const deleteCode = async (params) => {
	const { data } = await axios.post(`${API}/admin/codes/delete`, params);
	return data;
};

export const restoreCode = async (params) => {
	const { data } = await axios.post(`${API}/admin/codes/restore`, params);
	return data;
};
